import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/office-moving-and-storage.jpg'),
    alt: 'office moving and storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'office moving and storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Office <span>Moving</span><span>And Storage Services Available</span>',
  description:
    'Simplify your office relocation with professional moving and secure storage solutions. From packing to delivery, we ensure a smooth and efficient transition for your business.',
  image: {
    url: '/images/v2/pages/landing-pages/office-moving-and-storage/hero-image.jpg',
    alt: 'Office Moving And Storage Services Available'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for Office Moving & Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Our Office Moving and Storage Services Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/office-moving-and-storage/how-our-office-moving-and-storage-services-work.png',
    alt: 'How Our Office Moving and Storage Services Work'
  },

  articles: [
    {
      id: 1,
      title: 'Customized Moving Plans',
      description: 'We tailor our services to meet your business’s unique moving and storage needs.',
      image: {
        src: '/images/v2/pages/landing-pages/office-moving-and-storage/customized-moving-plans.png',
        alt: 'Customized Moving Plans'
      }
    },
    {
      id: 2,
      title: 'Secure Packing and Transport',
      description: 'Our experts handle all items with care, ensuring they arrive safely at their destination.',
      image: {
        src: '/images/v2/pages/landing-pages/office-moving-and-storage/secure-packing-and-transport.png',
        alt: 'Secure Packing and Transport'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Options',
      description: 'Store your office furniture, equipment, and documents in secure, climate-controlled facilities.',
      image: {
        src: '/images/v2/pages/landing-pages/office-moving-and-storage/flexible-storage-options.png',
        alt: 'Flexible Storage Options'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Fast And Secure Office Moving And Storage',
  description:
    'Our fast and secure office moving and storage services ensure a smooth transition with minimal downtime. We prioritize asset protection and offer comprehensive solutions tailored to your needs, providing peace of mind throughout the relocation process. Trust us to handle your office move efficiently and securely.',
  image: {
    src: '/images/v2/pages/landing-pages/office-moving-and-storage/fast-and-secure-office-moving-and-storage.jpg',
    alt: 'Fast And Secure Office Moving And Storage'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Our Services',

  cards: [
    {
      id: 1,
      title: 'Efficient Relocation',
      description: 'We manage the logistics of your office move, ensuring a seamless transition.',
      image: {
        src: '/images/v2/pages/common/convenient-locations.png',
        alt: 'Efficient Relocation'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Solutions',
      description: 'Keep your items safe in monitored storage units during or after the move.',
      image: {
        src: '/images/v2/pages/common/secure-and-reliable.png',
        alt: 'Secure Storage Solutions'
      }
    },
    {
      id: 3,
      title: 'Reduced Downtime',
      description: 'Our streamlined process helps you resume operations quickly and efficiently.',
      image: {
        src: '/images/v2/pages/common/reduced-downtime.png',
        alt: 'Reduced Downtime'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Our Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Small and Medium Businesses',
          description: 'Ensure a hassle-free move with affordable and efficient solutions.'
        },
        {
          id: 2,
          title: 'Large Corporations',
          description: 'Benefit from scalable services tailored to meet the demands of large-scale office relocations.'
        },
        {
          id: 3,
          title: 'Startups and Entrepreneurs',
          description: 'Easily transition to a new office space with reliable support.'
        },
        {
          id: 4,
          title: 'Co-Working Spaces',
          description: 'Relocate equipment and furnishings securely and efficiently.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/office-moving-and-storage/who-should-use-our-services.jpg',
        alt: 'Who Should Use Our Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Office Moving and Storage Services',

  cards: [
    {
      id: 1,
      title: 'Professional Office Movers',
      description: 'Expert packing and moving for furniture, electronics, and supplies.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Professional Office Movers'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Document Storage Services',
      description: 'Keep important files and records safe in our secure storage facilities.',
      image: {
        src: '/images/v2/pages/common/document-archiving.png',
        alt: 'Document Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Secure Office Storage',
      description: 'Short-term or long-term storage solutions for your office assets.',
      image: {
        src: '/images/v2/pages/common/short-term-and-long-term-storage.png',
        alt: 'Secure Office Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Custom Relocation Solutions',
      description: 'Tailored moving and storage plans to fit your business’s needs.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Custom Relocation Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Office Moving and Storage Services?',

  image: {
    url: '/images/v2/pages/landing-pages/office-moving-and-storage/why-choose-us-for-office-moving-and-storage-services.jpg',
    alt: 'Why Choose Us for Office Moving and Storage Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Experienced Professionals',
      description: 'Our team specializes in office moves, ensuring your business assets are handled with care.'
    },
    {
      id: 2,
      title: 'Secure Handling',
      description: 'State-of-the-art facilities and trained staff ensure the safety of your belongings.'
    },
    {
      id: 3,
      title: 'Comprehensive Solutions',
      description: 'From packing to storage, we provide end-to-end services for a hassle-free experience.'
    },
    {
      id: 4,
      title: 'Affordable Pricing',
      description: 'Transparent pricing with no hidden costs, tailored to fit your budget.'
    },
    {
      id: 5,
      title: 'Flexible Scheduling',
      description: 'Plan your move and storage around your business operations to minimize disruptions.'
    },
    {
      id: 6,
      title: 'Nationwide Coverage',
      description: 'We offer reliable moving and storage services across the country.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Office Moving And Storage Services Secure And Reliable',
  description:
    'Office moving and storage services available now. Fast and secure solutions for moving and storing your office items efficiently.',
  image: {
    src: '/images/v2/pages/landing-pages/office-moving-and-storage/office-moving-and-storage-services-secure-and-reliable.png',
    alt: 'Office Moving And Storage Services Secure And Reliable'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Your Office Move Today' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Moving and Storage Partners',
  description:
    'We collaborate with top-tier providers to ensure your office relocation and storage needs are met with excellence.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx delivers efficient logistics for office moves, ensuring timely and secure transportation.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides reliable moving and storage solutions for businesses worldwide.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers expert solutions for secure office moves and storage with global reach.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
